import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';
import styles from './LanguageSwitcher.module.css';

const LANGS = [
  { code: 'pt', country: 'BR', label: 'PT', name: 'Português' },
  { code: 'en', country: 'US', label: 'EN', name: 'English'   },
  { code: 'es', country: 'ES', label: 'ES', name: 'Español'   },
  { code: 'zh', country: 'CN', label: 'ZH', name: '中文'       },
  { code: 'la', country: 'VA', label: 'VA', name: 'Latim'     },
  { code: 'de', country: 'DE', label: 'DE', name: 'Deutsch'  },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = LANGS.find(l => l.code === i18n.language?.slice(0, 2)) ?? LANGS[0];
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const select = (code) => { i18n.changeLanguage(code); setOpen(false); };

  return (
    <div className={styles.wrapper} ref={ref}>
      <button
        className={`${styles.trigger} ${open ? styles.triggerOpen : ''}`}
        onClick={() => setOpen(o => !o)}
        aria-label="Change language"
      >
        <ReactCountryFlag
          countryCode={current.country}
          svg
          style={{ width: '1.2em', height: '1.2em', borderRadius: '2px' }}
        />
        <span className={styles.label}>{current.label}</span>
        <svg
          className={`${styles.arrow} ${open ? styles.arrowOpen : ''}`}
          width="10" height="10" viewBox="0 0 10 10"
        >
          <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </svg>
      </button>

      {open && (
        <div className={styles.dropdown}>
          {LANGS.map(lang => (
            <button
              key={lang.code}
              className={`${styles.option} ${current.code === lang.code ? styles.optionActive : ''}`}
              onClick={() => select(lang.code)}
            >
              <ReactCountryFlag
                countryCode={lang.country}
                svg
                style={{ width: '1.2em', height: '1.2em', borderRadius: '2px', flexShrink: 0 }}
              />
              <span className={styles.optionName}>{lang.name}</span>
              {current.code === lang.code && (
                <svg width="12" height="12" viewBox="0 0 12 12">
                  <path d="M2 6L5 9L10 3" stroke="#0BFF5B" strokeWidth="1.8"
                    strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
